import { render } from "./ClusCnfScrn.vue?vue&type=template&id=24a5cac6"
import script from "./ClusCnfScrn.vue?vue&type=script&lang=js"
export * from "./ClusCnfScrn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__